import register from '../../util/init'
import { ajaxUrl } from '../../util/ajax_util'
import InfScr from '../../util/infscr'
import {fakeLazyLoad} from '../../util/tools'

class initPage {
  constructor (container) {
    this.container = container
    // Initialise infsrc
    const infscrInstance = this.initInfscr()

    return {
      resize: (w, h) => {
        infscrInstance.resize(w, h)
      },
      scroll: (top, left) => {
        infscrInstance.scroll(top, left)
      }
    }
  }
  initInfscr () {
    /**
   * setup an infinite scrolling page
   * extended docs - https://github.com/gregplaysguitar/infscr/
   * some minor alteration have been made to this version
   *
   * @method initInfscr
   * @return {function instance} InfScr
   */

    return InfScr(this.container.querySelector('.page'), {
      contentSelector: '.page-items',
      nextSelector: '.next-page',
      autoOffset: 1500,
      // cache: false,
      get_url: (link) => {
        return ajaxUrl(link.getAttribute('href'))
      },
      beforeLoad: function () {
        // ...
      },
      onLoad: function (newContent, container) {
        // ...
        // bind all lazy images
        container.querySelectorAll('.lazyload').forEach((el) => {
          fakeLazyLoad(el)
        })
      }
    })
  }
}
register('.features-content', initPage)



// WEBPACK FOOTER //
// ./assets/j/src/features/index.js